export default "__VITE_ASSET__9ec7400d__"